var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tracker-card" }, [
    _c(
      "div",
      {
        staticClass: "tracker-card__wrapper",
        class: { "not-subscribe": _vm.notSubscribe },
      },
      [
        _c(
          "div",
          { staticClass: "tracker-card__date" },
          [_c("Date", { attrs: { text: _vm.date } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tracker-card__header" },
          [
            _vm.hasAccess
              ? _c("nuxt-link", { attrs: { to: _vm.link, target: "_blank" } }, [
                  _vm._v(_vm._s(_vm.title)),
                ])
              : _c(
                  "nuxt-link",
                  { staticClass: "unauthorised", attrs: { to: "#" } },
                  [_vm._v(_vm._s(_vm.noAccessShort))]
                ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "tracker-card__header-direction",
                class: { open: _vm.showMore },
                on: {
                  click: function ($event) {
                    return _vm.getMoreInfo(_vm.item.nid)
                  },
                },
              },
              [_c("Icon", { attrs: { icon: "arrow-red" } })],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "tracker-card__content section-border--top section-border--right section-border--bottom",
          },
          [
            _vm.item.documentTypes && _vm.item.documentTypes.length
              ? _c("div", { staticClass: "tracker-card__item-row" }, [
                  _c("div", { staticClass: "tracker-card__item-title" }, [
                    _vm._v("Document type"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tracker-card__item-value" },
                    _vm._l(_vm.item.documentTypes, function (documentType) {
                      return _c("span", { key: documentType.tid }, [
                        _vm._v(_vm._s(documentType.title) + ",\n          "),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.datePublished
              ? _c("div", { staticClass: "tracker-card__item-row" }, [
                  _c("div", { staticClass: "tracker-card__item-title" }, [
                    _vm._v("Date published"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tracker-card__item-value" },
                    [_c("Date", { attrs: { text: _vm.item.datePublished } })],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.effectiveDate
              ? _c("div", { staticClass: "tracker-card__item-row" }, [
                  _c("div", { staticClass: "tracker-card__item-title" }, [
                    _vm._v("Effective date"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tracker-card__item-value" },
                    [_c("Date", { attrs: { text: _vm.item.effectiveDate } })],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.responseDeadline
              ? _c("div", { staticClass: "tracker-card__item-row" }, [
                  _c("div", { staticClass: "tracker-card__item-title" }, [
                    _vm._v("Response deadline"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tracker-card__item-value" },
                    [
                      _c("Date", {
                        attrs: { text: _vm.item.responseDeadline },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.companies && _vm.item.companies.length
              ? _c("div", { staticClass: "tracker-card__item-row" }, [
                  _c("div", { staticClass: "tracker-card__item-title" }, [
                    _vm._v("Company"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tracker-card__item-value" },
                    _vm._l(_vm.item.companies, function (company) {
                      return _c("span", { key: company.tid }, [
                        _vm._v(_vm._s(company.title) + ",\n          "),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.authorities
              ? _c("div", { staticClass: "tracker-card__item-row" }, [
                  _c("div", { staticClass: "tracker-card__item-title" }, [
                    _vm._v("Authority"),
                  ]),
                  _vm._v(" "),
                  _vm.hasAccess
                    ? _c(
                        "div",
                        { staticClass: "tracker-card__item-value" },
                        _vm._l(_vm.item.authorities, function (authority) {
                          return _c("span", { key: authority.tid }, [
                            _vm._v(_vm._s(authority.title) + ",\n          "),
                          ])
                        }),
                        0
                      )
                    : _c("div", { staticClass: "tracker-card__item-value" }, [
                        _c("span", { staticClass: "unauthorised" }, [
                          _vm._v(_vm._s(_vm.noAccessShort)),
                        ]),
                      ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "tracker-card__item-wrap" }, [
              _vm.hasAccess
                ? _c("div", {
                    staticClass: "tracker-card__item-text",
                    domProps: { innerHTML: _vm._s(_vm.item.body) },
                  })
                : _c(
                    "div",
                    { staticClass: "tracker-card__item-text unauthorised" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.noAccessShort) +
                          "\n        "
                      ),
                    ]
                  ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tracker-card__item-link" },
              [
                _c("nuxt-link", { attrs: { to: _vm.link, target: "_blank" } }, [
                  _vm._v(" Read more "),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showMore
              ? _c("div", { staticClass: "tracker-card__item-hide" }, [
                  _vm.parents
                    ? _c(
                        "div",
                        { staticClass: "tracker-card__item-parents" },
                        _vm._l(_vm.parents, function (parent, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "tracker-card__item-parent tracker-card__item-child",
                            },
                            [
                              _c("Date", { attrs: { text: parent.created } }),
                              _vm._v(" "),
                              _c(
                                "nuxt-link",
                                { attrs: { to: parent.view_node } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(parent.title) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.notSubscribe ? _c("Tooltip") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }